//Section 1
import SurveyStepAddress from 'components/pages/surveys/survey-cra/section-1/survey-step-address.vue';
import SurveyStepGender from 'components/pages/surveys/survey-cra/section-1/survey-step-gender.vue';
import SurveyStepBirthdate from 'components/pages/surveys/survey-cra/section-1/survey-step-birthdate.vue';
import SurveyStepEthnicity from 'components/pages/surveys/survey-cra/section-1/survey-step-ethnicity.vue';
import SurveyStepHeight from 'components/pages/surveys/survey-cra/section-1/survey-step-height.vue';
import SurveyStepWeight from 'components/pages/surveys/survey-cra/section-1/survey-step-weight.vue';
import SurveyStepWaist from 'components/pages/surveys/survey-cra/section-1/survey-step-waist.vue';
import SurveyStepRecentBloodPressure from 'components/pages/surveys/survey-cra/section-1/survey-step-recent-blood-pressure.vue';
//Section 2
import SurveyStepHighBloodPressure from 'components/pages/surveys/survey-cra/section-2/survey-step-high-blood-pressure.vue';
import SurveyStepBloodPressureMedication from 'components/pages/surveys/survey-cra/section-2/survey-step-blood-pressure-medication.vue';
//Section3
import SurveyStepBloodSugarElevated from 'components/pages/surveys/survey-cra/section-3/survey-step-blood-sugar-elevated.vue';
import SurveyStepDiabetesHistory from 'components/pages/surveys/survey-cra/section-3/survey-step-diabetes-history.vue';
import SurveyStepTypeOneDiabetes from 'components/pages/surveys/survey-cra/section-3/survey-step-type-one-diabetes.vue';
import SurveyStepTypeTwoDiabetes from 'components/pages/surveys/survey-cra/section-3/survey-step-type-two-diabetes.vue';
import SurveyStepBloodSugarMedication from 'components/pages/surveys/survey-cra/section-3/survey-step-blood-sugar-medication.vue';
import SurveyStepDiabeticDiseases from 'components/pages/surveys/survey-cra/section-3/survey-step-diabetic-diseases.vue';
import SurveyStepPregnancy from 'components/pages/surveys/survey-cra/section-3/survey-step-pregnancy.vue';
import SurveyStepParents from 'components/pages/surveys/survey-cra/section-3/survey-step-parents.vue';
import SurveyStepTypeTwoRemission from 'components/pages/surveys/survey-cra/section-3/survey-step-type-two-remission.vue';
//Section 4
import SurveyStepFamilyPrematureHeartAttack from 'components/pages/surveys/survey-cra/section-4/survey-step-family-premature-heart-attack.vue';
import SurveyStepBlockageHistory from 'components/pages/surveys/survey-cra/section-4/survey-step-blockage-history.vue';
import SurveyStepBlockageTests from 'components/pages/surveys/survey-cra/section-4/survey-step-blockage-tests.vue';
import SurveyStepLastCacTest from 'components/pages/surveys/survey-cra/section-4/survey-step-last-cac-test.vue';
import SurveyStepLastHeartAngiogram from 'components/pages/surveys/survey-cra/section-4/survey-step-last-heart-angiogram.vue';
import SurveyStepLastCtAngiogram from 'components/pages/surveys/survey-cra/section-4/survey-step-last-ct-angiogram.vue';
import SurveyStepLastCimtTest from 'components/pages/surveys/survey-cra/section-4/survey-step-last-cimt-test.vue';
import SurveyStepLastLegAngiogram from 'components/pages/surveys/survey-cra/section-4/survey-step-last-leg-angiogram.vue';
import SurveyStepLastAnkleBrachialTest from 'components/pages/surveys/survey-cra/section-4/survey-step-last-ankle-brachial-test.vue';
import SurveyStepLastAngiogramCarotid from 'components/pages/surveys/survey-cra/section-4/survey-step-last-angiogram-carotid-test.vue';
import SurveyStepArteryBlockage from 'components/pages/surveys/survey-cra/section-4/survey-step-artery-blockage.vue';
import SurveyStepArteryBlockageExperience from 'components/pages/surveys/survey-cra/section-4/survey-step-artery-blockage-experience.vue';
import SurveyStepArterySymptomDates from 'components/pages/surveys/survey-cra/section-4/survey-step-artery-symptom-dates.vue';
import SurveyStepStrokeExperience from 'components/pages/surveys/survey-cra/section-4/survey-step-stroke-experience.vue';
import SurveyStepStrokeDates from 'components/pages/surveys/survey-cra/section-4/survey-step-stroke-dates.vue';
import SurveyStepHeartAttackExperience from 'components/pages/surveys/survey-cra/section-4/survey-step-heart-attack-experience.vue';
import SurveyStepHeartAttackDates from 'components/pages/surveys/survey-cra/section-4/survey-step-heart-attack-dates.vue';
import SurveyStepHeartArteryProcedures from 'components/pages/surveys/survey-cra/section-4/survey-step-heart-artery-procedures.vue';
import SurveyStepHeartBalloonOpeningDates from 'components/pages/surveys/survey-cra/section-4/survey-step-heart-balloon-opening-dates.vue';
import SurveyStepHeartStentDates from 'components/pages/surveys/survey-cra/section-4/survey-step-heart-stent-dates.vue';
import SurveyStepHeartBypassSurgeryDates from 'components/pages/surveys/survey-cra/section-4/survey-step-heart-bypass-surgery-dates.vue';
import SurveyStepLegArteryProcedures from 'components/pages/surveys/survey-cra/section-4/survey-step-leg-artery-procedures.vue';
import SurveyStepLegBalloonOpeningDates from 'components/pages/surveys/survey-cra/section-4/survey-step-leg-balloon-opening-dates.vue';
import SurveyStepLegStentDates from 'components/pages/surveys/survey-cra/section-4/survey-step-leg-stent-dates.vue';
import SurveyStepLegBypassSurgeryDates from 'components/pages/surveys/survey-cra/section-4/survey-step-leg-bypass-surgery-dates.vue';
import SurveyStepNeckArteryProcedures from 'components/pages/surveys/survey-cra/section-4/survey-step-neck-artery-procedures.vue';
import SurveyStepNeckBlockageSurgeryDates from 'components/pages/surveys/survey-cra/section-4/survey-step-neck-blockage-surgery-dates.vue';
import SurveyStepNeckStentDates from 'components/pages/surveys/survey-cra/section-4/survey-step-neck-stent-dates.vue';
//Section 5
import SurveyStepHighestCholesterolLevel from 'components/pages/surveys/survey-cra/section-5/survey-step-highest-cholesterol-level.vue';
import SurveyStepCholesterolRange from 'components/pages/surveys/survey-cra/section-5/survey-step-cholesterol-range.vue';
import SurveyStepHypercholesterolemia from 'components/pages/surveys/survey-cra/section-5/survey-step-hypercholesterolemia.vue';
import SurveyStepHypercholesterolemiaTest from 'components/pages/surveys/survey-cra/section-5/survey-step-hypercholesterolemia-test.vue';
import SurveyStepHypercholesterolemiaDiagnoses from 'components/pages/surveys/survey-cra/section-5/survey-step-hypercholesterolemia-diagnoses.vue';
import SurveyStepFamilyDiagnoses from 'components/pages/surveys/survey-cra/section-5/survey-step-family-diagnoses.vue';
import SurveyStepHypercholesterolemiaFamilyDiagnoses from 'components/pages/surveys/survey-cra/section-5/survey-step-hypercholesterolemia-family-diagnoses.vue';
import SurveyStepLowestCholesterolLevel from 'components/pages/surveys/survey-cra/section-5/survey-step-lowest-cholesterol-level.vue';
import SurveyStepHighestTriglycerideLevel from 'components/pages/surveys/survey-cra/section-5/survey-step-highest-triglyceride-level.vue';
import SurveyStepTriglycerideMedication from 'components/pages/surveys/survey-cra/section-5/survey-step-triglyceride-medication.vue';
import SurveyStepTriglycerideManagement from 'components/pages/surveys/survey-cra/section-5/survey-step-triglyceride-management.vue';
import SurveyStepCholesterolMedication from 'components/pages/surveys/survey-cra/section-5/survey-step-cholesterol-medication.vue';
import SurveyStepCholesterolMedicationDuringAscvd from 'components/pages/surveys/survey-cra/section-5/survey-step-cholesterol-medication-during-ascvd.vue';
import SurveyStepCholesterolStatin from 'components/pages/surveys/survey-cra/section-5/survey-step-cholesterol-statin.vue';
import SurveyStepCholesterolTest from 'components/pages/surveys/survey-cra/section-5/survey-step-cholesterol-test.vue';
import SurveyStepApolipoproteinBTest from 'components/pages/surveys/survey-cra/section-5/survey-step-apolipoprotein-b-test.vue';
import SurveyStepLipoproteinATest from 'components/pages/surveys/survey-cra/section-5/survey-step-lipoprotein-a-test.vue';
//Section 6
import SurveyStepSmokingStatus from 'components/pages/surveys/survey-cra/section-6/survey-step-smoking-status.vue';
import SurveyStepSmokingCurrently from 'components/pages/surveys/survey-cra/section-6/survey-step-smoking-currently.vue';
import SurveyStepSmokingPast from 'components/pages/surveys/survey-cra/section-6/survey-step-smoking-past.vue';
import SurveyStepSmokingSmokeless from 'components/pages/surveys/survey-cra/section-6/survey-step-smoking-smokeless.vue';
//Section 7
import SurveyStepMetabolicSyndrome from 'components/pages/surveys/survey-cra/section-7/survey-step-metabolic-syndrome.vue';
import SurveyStepMetabolicConditions from 'components/pages/surveys/survey-cra/section-7/survey-step-metabolic-conditions.vue';
import SurveyStepConditionsTold from 'components/pages/surveys/survey-cra/section-7/survey-step-conditions-told.vue';
import SurveyStepCKD from 'components/pages/surveys/survey-cra/section-7/survey-step-ckd.vue';
import SurveyStepCKDStage from 'components/pages/surveys/survey-cra/section-7/survey-step-ckd-stage.vue';
import SurveyStepChronicInflammatoryConditions from 'components/pages/surveys/survey-cra/section-7/survey-step-chronic-inflammatory-conditions.vue';
import SurveyStepSensitivityHsCrp from 'components/pages/surveys/survey-cra/section-7/survey-step-sensitivity-hs-crp.vue';
import SurveyStepGlyca from 'components/pages/surveys/survey-cra/section-7/survey-step-glyca.vue';
import SurveyStepFemaleMedicalConditions from 'components/pages/surveys/survey-cra/section-7/survey-step-female-medical-conditions.vue';
import SurveyStepPayment from 'components/pages/surveys/survey-step-payment.vue';
import SurveyStepErectileDysfunction from 'components/pages/surveys/survey-cra/section-7/survey-step-erectile-dysfunction.vue';
//Section 8
import SurveyStepReportInformed from 'components/pages/surveys/survey-cra/section-8/survey-step-report-informed.vue';
import SurveyStepLifestyleRecommendation from 'components/pages/surveys/survey-cra/section-8/survey-step-diet-lifestyle-recommendation.vue';
import SurveyStepChangeFollowing from 'components/pages/surveys/survey-cra/section-8/survey-step-change-following.vue';
import SurveyStepHealthControl from 'components/pages/surveys/survey-cra/section-8/survey-step-health-control.vue';
//Section 9 Lifestyle Factors
import SurveyPhysicalRating from 'components/pages/surveys/survey-cra/section-9-lifestyle-factors/survey-step-physical-rating.vue';
import SurveyMentalRating from 'components/pages/surveys/survey-cra/section-9-lifestyle-factors/survey-step-mental-rating.vue';
import SurveySleepRating from 'components/pages/surveys/survey-cra/section-9-lifestyle-factors/survey-step-sleep-rating.vue';
import SurveyStressManagementRating from 'components/pages/surveys/survey-cra/section-9-lifestyle-factors/survey-step-stress-management-rating.vue';
import SurveyNutritionalRating from 'components/pages/surveys/survey-cra/section-9-lifestyle-factors/survey-step-nutritional-rating.vue';
import SurveyExerciseRating from 'components/pages/surveys/survey-cra/section-9-lifestyle-factors/survey-step-exercise-rating.vue';

export const RepeatedAdvancedSurveySteps = [
  {// 6
    id: "weight",
    component: SurveyStepWeight,
    active: true
  },
  {// 7
    id: "waist",
    component: SurveyStepWaist,
    active: true
  },
  {// 8
    id: "recent-blood-pressure",
    component: SurveyStepRecentBloodPressure,
    active: true
  },
  {// 9
    id: "high-blood-pressure",
    component: SurveyStepHighBloodPressure,
    active: true,
    header: "Blood pressure values are an important part of your cardiometabolic health."
  },
  {// 10
    id: "blood-pressure-medication",
    component: SurveyStepBloodPressureMedication,
    active: true
  },
  {// 11
    id: "blood-sugar-elevated",
    component: SurveyStepBloodSugarElevated,
    active: true,
    header: "Blood sugar (also called \"glucose\") is an important part of your cardiometabolic health."
  },
  {// 12
    id: "diabetes-history",
    component: SurveyStepDiabetesHistory,
    active: true
  },
  {// 12b
    id: "diabetes-type-two-remission",
    component: SurveyStepTypeTwoRemission,
    active: false
  },
  {// 13
    id: "type-one-diabetes",
    component: SurveyStepTypeOneDiabetes,
    active: true
  },
  {// 14
    id: "type-two-diabetes",
    component: SurveyStepTypeTwoDiabetes,
    active: true
  },
  {// 15
    id: "blood-sugar-medication",
    component: SurveyStepBloodSugarMedication,
    active: true
  },
  {// 17
    id: "pregnancy",
    component: SurveyStepPregnancy,
    active: false
  },
  {// 55
    id: "triglyceride-medication",
    component: SurveyStepTriglycerideMedication,
    active: true
  },
  {// 57
    id: "triglyceride-management",
    component: SurveyStepTriglycerideManagement,
    active: true
  },
  {// 56
    id: "cholesterol-medication",
    component: SurveyStepCholesterolMedication,
    active: true
  },
  {// 58
    id: "cholesterol-statin",
    component: SurveyStepCholesterolStatin,
    active: true
  },
  {// payment
    id: "payment",
    component: SurveyStepPayment,
    active: true
  },
];

export const InitialAdvancedSurveySteps = [
  {// 1
    id: "address",
    component: SurveyStepAddress,
    active: true,
    header: 'To start, let’s gather a little information about you. This should take about 3 minutes. Honestly and accurately answering each question as best as possible is important in allowing us to provide you an accurate assessment.'
  },
  {// 2
    id: "gender",
    component: SurveyStepGender,
    active: true
  },
  {// 72
    id: "female-medical-conditions",
    component: SurveyStepFemaleMedicalConditions,
    active: false
  },
  {// 3
    id: "birthdate",
    component: SurveyStepBirthdate,
    active: true
  },
  {// 4
    id: "ethnicity",
    component: SurveyStepEthnicity,
    active: true
  },
  {// 5
    id: "height",
    component: SurveyStepHeight,
    active: true
  },
  {// 6
    id: "weight",
    component: SurveyStepWeight,
    active: true
  },
  {// 7
    id: "waist",
    component: SurveyStepWaist,
    active: true
  },
  {// 8
    id: "recent-blood-pressure",
    component: SurveyStepRecentBloodPressure,
    active: true
  },
  {// 9
    id: "high-blood-pressure",
    component: SurveyStepHighBloodPressure,
    active: true,
    header: "Blood pressure values are an important part of your cardiometabolic health."
  },
  {// 10
    id: "blood-pressure-medication",
    component: SurveyStepBloodPressureMedication,
    active: true
  },
  {// 11
    id: "blood-sugar-elevated",
    component: SurveyStepBloodSugarElevated,
    active: true,
    header: "Blood sugar (also called \"glucose\") is an important part of your cardiometabolic health."
  },
  {// 12
    id: "diabetes-history",
    component: SurveyStepDiabetesHistory,
    active: true
  },
  {// 12b
    id: "diabetes-type-two-remission",
    component: SurveyStepTypeTwoRemission,
    active: false
  },
  {// 13
    id: "type-one-diabetes",
    component: SurveyStepTypeOneDiabetes,
    active: true
  },
  {// 14
    id: "type-two-diabetes",
    component: SurveyStepTypeTwoDiabetes,
    active: true
  },
  {// 15
    id: "blood-sugar-medication",
    component: SurveyStepBloodSugarMedication,
    active: true
  },
  {// 17
    id: "pregnancy",
    component: SurveyStepPregnancy,
    active: false
  },
  {// 18
    id: "parents",
    component: SurveyStepParents,
    active: true
  },
  {// 55
    id: "triglyceride-medication",
    component: SurveyStepTriglycerideMedication,
    active: true
  },
  {// 57
    id: "triglyceride-management",
    component: SurveyStepTriglycerideManagement,
    active: true
  },
  {// 56
    id: "cholesterol-medication",
    component: SurveyStepCholesterolMedication,
    active: true
  },
  {// 58
    id: "cholesterol-statin",
    component: SurveyStepCholesterolStatin,
    active: true
  },
  {// payment
    id: "payment",
    component: SurveyStepPayment,
    active: true
  },
];

export const InitialSurveySteps = [
  //Section 1
  {// 1
    id: "address",
    component: SurveyStepAddress,
    active: true,
    header: 'To start, let’s gather a little information about you. This should take about 3 minutes. Honestly and accurately answering each question as best as possible is important in allowing us to provide you an accurate assessment.'
  },
  {// 2
    id: "gender",
    component: SurveyStepGender,
    active: true
  },
  {// 3
    id: "birthdate",
    component: SurveyStepBirthdate,
    active: true
  },
  {// 4
    id: "ethnicity",
    component: SurveyStepEthnicity,
    active: true
  },
  {// 5
    id: "height",
    component: SurveyStepHeight,
    active: true
  },
  {// 6
    id: "weight",
    component: SurveyStepWeight,
    active: true
  },
  {// 7
    id: "waist",
    component: SurveyStepWaist,
    active: true
  },
  {// 8
    id: "recent-blood-pressure",
    component: SurveyStepRecentBloodPressure,
    active: true
  },
  //Section 2
  {// 9
    id: "high-blood-pressure",
    component: SurveyStepHighBloodPressure,
    active: true,
    header: "Blood pressure values are an important part of your cardiometabolic health."
  },
  {// 10
    id: "blood-pressure-medication",
    component: SurveyStepBloodPressureMedication,
    active: true
  },
  //Section 3
  {// 11
    id: "blood-sugar-elevated",
    component: SurveyStepBloodSugarElevated,
    active: true,
    header: "Blood sugar (also called \"glucose\") is an important part of your cardiometabolic health."
  },
  {// 12
    id: "diabetes-history",
    component: SurveyStepDiabetesHistory,
    active: true
  },
  {// 12b
    id: "diabetes-type-two-remission",
    component: SurveyStepTypeTwoRemission,
    active: false
  },
  {// 13
    id: "type-one-diabetes",
    component: SurveyStepTypeOneDiabetes,
    active: true
  },
  {// 14
    id: "type-two-diabetes",
    component: SurveyStepTypeTwoDiabetes,
    active: true
  },
  {// 15
    id: "blood-sugar-medication",
    component: SurveyStepBloodSugarMedication,
    active: true
  },
  {// 16
    id: "diabetic-diseases",
    component: SurveyStepDiabeticDiseases,
    active: true
  },
  {// 17
    id: "pregnancy",
    component: SurveyStepPregnancy,
    active: false
  },
  {// 18
    id: "parents",
    component: SurveyStepParents,
    active: true
  },
  //Section 4
  {// 19
    id: "family-premature-heart-attack",
    component: SurveyStepFamilyPrematureHeartAttack,
    active: true,
    header: "Your cardiovascular health is a very important consideration for determining your future cardiometabolic risk."
  },
  {// 20
    id: "blockage-history",
    component: SurveyStepBlockageHistory,
    active: true
  },
  {// 21
    id: "blockage-tests",
    component: SurveyStepBlockageTests,
    active: true
  },
  {// 22
    id: "last-cac-test",
    component: SurveyStepLastCacTest,
    active: true
  },
  {// 23
    id: "last-heart-angiogram",
    component: SurveyStepLastHeartAngiogram,
    active: true
  },
  {// 24
    id: "last-ct-angiogram",
    component: SurveyStepLastCtAngiogram,
    active: true
  },
  {// 25
    id: "last-cimt-test",
    component: SurveyStepLastCimtTest,
    active: true
  },
  {// 26
    id: "last-leg-angiogram",
    component: SurveyStepLastLegAngiogram,
    active: true
  },
  {// 27
    id: "last-ankle-branchial-test",
    component: SurveyStepLastAnkleBrachialTest,
    active: true
  },
  {// 27b
    id: "last-angiogram-carotid-test",
    component: SurveyStepLastAngiogramCarotid,
    active: true
  },
  {// 28
    id: "artery-blockage",
    component: SurveyStepArteryBlockage,
    active: true
  },
  {// 29
    id: "artery-blockage-experience",
    component: SurveyStepArteryBlockageExperience,
    active: true
  },
  {// 30
    id: "artery-symptom-dates",
    component: SurveyStepArterySymptomDates,
    active: true
  },
  {// 31
    id: "stroke-experience",
    component: SurveyStepStrokeExperience,
    active: true
  },
  {// 32
    id: "stroke-dates",
    component: SurveyStepStrokeDates,
    active: true
  },
  {// 33
    id: "heart-attack-experience",
    component: SurveyStepHeartAttackExperience,
    active: true
  },
  {// 34
    id: "heart-attack-dates",
    component: SurveyStepHeartAttackDates,
    active: true
  },
  {// 35
    id: "heart-artery-procedures",
    component: SurveyStepHeartArteryProcedures,
    active: true
  },
  {// 36
    id: "heart-balloon-opening-dates",
    component: SurveyStepHeartBalloonOpeningDates,
    active: true
  },
  {// 37
    id: "heart-stent-dates",
    component: SurveyStepHeartStentDates,
    active: true
  },
  {// 38
    id: "heart-bypass-surgery-dates",
    component: SurveyStepHeartBypassSurgeryDates,
    active: true
  },
  {// 39
    id: "leg-artery-procedures",
    component: SurveyStepLegArteryProcedures,
    active: true
  },
  {// 40
    id: "leg-ballon-opening-dates",
    component: SurveyStepLegBalloonOpeningDates,
    active: true
  },
  {// 41
    id: "leg-stent-dates",
    component: SurveyStepLegStentDates,
    active: true
  },
  {// 42
    id: "leg-bypass-surgery-dates",
    component: SurveyStepLegBypassSurgeryDates,
    active: true
  },
  {// 43
    id: "neck-artery-procedures",
    component: SurveyStepNeckArteryProcedures,
    active: true
  },
  {// 44
    id: "neck-blockage-surgery-dates",
    component: SurveyStepNeckBlockageSurgeryDates,
    active: true
  },
  {// 45
    id: "neck-stent-dates",
    component: SurveyStepNeckStentDates,
    active: true
  },
  //Section 5
  {// 46
    id: "highest-cholesterol-level",
    component: SurveyStepHighestCholesterolLevel,
    active: true,
    header: "Information about blood lipids (cholesterol and triglycerides) and lipoproteins (particles that carry cholesterol in the blood) is an important part of your cardiometabolic health."
  },
  {// 47
    id: "cholesterol-range",
    component: SurveyStepCholesterolRange,
    active: true
  },
  {// 48
    id: "hypercholesterolemia",
    component: SurveyStepHypercholesterolemia,
    active: true
  },
  {// 49
    id: "hypercholesterolemia-test",
    component: SurveyStepHypercholesterolemiaTest,
    active: true
  },
  {// 50
    id: "hypercholesterolemia-diagnoses",
    component: SurveyStepHypercholesterolemiaDiagnoses,
    active: true
  },
  {// 51
    id: "family-diagnoses",
    component: SurveyStepFamilyDiagnoses,
    active: true
  },
  {// 52
    id: "hypercholesterolemia-family-diagnoses",
    component: SurveyStepHypercholesterolemiaFamilyDiagnoses,
    active: true
  },
  {// 53
    id: "lowest-cholesterol-level",
    component: SurveyStepLowestCholesterolLevel,
    active: false
  },
  {// 54
    id: "highest-triglyceride-level",
    component: SurveyStepHighestTriglycerideLevel,
    active: false
  },
  {// 55
    id: "triglyceride-medication",
    component: SurveyStepTriglycerideMedication,
    active: true
  },
  {// 56
    id: "cholesterol-medication",
    component: SurveyStepCholesterolMedication,
    active: true
  },
  {// 57
    id: "triglyceride-management",
    component: SurveyStepTriglycerideManagement,
    active: true
  },
  {// 58
    id: "cholesterol-statin",
    component: SurveyStepCholesterolStatin,
    active: true
  },
  {// 58b
    id: "cholesterol-medication-during-ascvd",
    component: SurveyStepCholesterolMedicationDuringAscvd,
    active: true
  },
  {// 59
    id: "cholesterol-test",
    component: SurveyStepCholesterolTest,
    active: false
  },
  {// 60
    id: "apoliprotein-b-test",
    component: SurveyStepApolipoproteinBTest,
    active: false
  },
  {// 61
    id: "lipoprotein-a-test",
    component: SurveyStepLipoproteinATest,
    active: false
  },
  //Section 6
  {// 62
    id: "smoking-status",
    component: SurveyStepSmokingStatus,
    active: true,
    header: "Whether you currently or have previously smoked plays an important role in your cardiovascular health."
  },
  {// 63
    id: "smoking-currently",
    component: SurveyStepSmokingCurrently,
    active: true
  },
  {// 64
    id: "smoking-past",
    component: SurveyStepSmokingPast,
    active: true
  },
  {// 64b
    id: "smoking-smokeless",
    component: SurveyStepSmokingSmokeless,
    active: true
  },
  //Section 7
  {// 65
    id: "metabolic-syndrome",
    component: SurveyStepMetabolicSyndrome,
    active: true,
    header: "Several medical conditions run hand-in-hand with cardiometabolic risk. These different conditions have different impacts in determining your risk factors. Please answer the following questions as completely as possible."
  },
  {// 66
    id: "metabolic-conditions",
    component: SurveyStepMetabolicConditions,
    active: true
  },
  {// 67
    id: "conditions-told",
    component: SurveyStepConditionsTold,
    active: true
  },
  {// 68
    id: "ckd",
    component: SurveyStepCKD,
    active: true
  },
  {// 69
    id: "ckd-stage",
    component: SurveyStepCKDStage,
    active: true
  },
  {// 70
    id: "chronic-inflammatory-conditions",
    component: SurveyStepChronicInflammatoryConditions,
    active: true
  },
  {// 71
    id: "sensitivity-hs-crp",
    component: SurveyStepSensitivityHsCrp,
    active: false
  },
  {// 71a
    id: "glyca",
    component: SurveyStepGlyca,
    active: false
  },
  {// 72
    id: "female-medical-conditions",
    component: SurveyStepFemaleMedicalConditions,
    active: false
  },
  {//76
    id: "erectile-dysfunction",
    component: SurveyStepErectileDysfunction,
    active: false
  },
  {// payment
    id: "payment",
    component: SurveyStepPayment,
    active: true
  }
]

export const RepeatedSurveySteps = [
  //Section 1
  {// 6
    id: "weight",
    component: SurveyStepWeight,
    active: true,
    header: 'To start, let’s gather a little information about you. This should take about 3 minutes. Honestly and accurately answering each question as best as possible is important in allowing us to provide you an accurate assessment.'
  },
  {// 7
    id: "waist",
    component: SurveyStepWaist,
    active: true
  },
  {// 8
    id: "recent-blood-pressure",
    component: SurveyStepRecentBloodPressure,
    active: true
  },
  //Section 2
  {// 9
    id: "high-blood-pressure",
    component: SurveyStepHighBloodPressure,
    active: true,
    header: "Blood pressure values are an important part of your cardiometabolic health."
  },
  {// 10
    id: "blood-pressure-medication",
    component: SurveyStepBloodPressureMedication,
    active: true
  },
  //Section 3
  {// 11
    id: "blood-sugar-elevated",
    component: SurveyStepBloodSugarElevated,
    active: true,
    header: "Blood sugar (also called \"glucose\") is an important part of your cardiometabolic health."
  },
  {// 12
    id: "diabetes-history",
    component: SurveyStepDiabetesHistory,
    active: true
  },
  {// 12b
    id: "diabetes-type-two-remission",
    component: SurveyStepTypeTwoRemission,
    active: false
  },
  {// 13
    id: "type-one-diabetes",
    component: SurveyStepTypeOneDiabetes,
    active: true
  },
  {// 14
    id: "type-two-diabetes",
    component: SurveyStepTypeTwoDiabetes,
    active: true
  },
  {// 15
    id: "blood-sugar-medication",
    component: SurveyStepBloodSugarMedication,
    active: true
  },
  {// 16
    id: "diabetic-diseases",
    component: SurveyStepDiabeticDiseases,
    active: true
  },
  {// 17
    id: "pregnancy",
    component: SurveyStepPregnancy,
    active: true
  },
  //Section 4
  {// 19
    id: "family-premature-heart-attack",
    component: SurveyStepFamilyPrematureHeartAttack,
    active: true,
    header: "Your cardiovascular health is a very important consideration for determining your future cardiometabolic risk."
  },
  {// 20
    id: "blockage-history",
    component: SurveyStepBlockageHistory,
    active: true
  },
  {// 21
    id: "blockage-tests",
    component: SurveyStepBlockageTests,
    active: true
  },
  {// 22
    id: "last-cac-test",
    component: SurveyStepLastCacTest,
    active: true
  },
  {// 23
    id: "last-heart-angiogram",
    component: SurveyStepLastHeartAngiogram,
    active: true
  },
  {// 24
    id: "last-ct-angiogram",
    component: SurveyStepLastCtAngiogram,
    active: true
  },
  {// 25
    id: "last-cimt-test",
    component: SurveyStepLastCimtTest,
    active: true
  },
  {// 26
    id: "last-leg-angiogram",
    component: SurveyStepLastLegAngiogram,
    active: true
  },
  {// 27
    id: "last-ankle-branchial-test",
    component: SurveyStepLastAnkleBrachialTest,
    active: true
  },
  {// 27b
    id: "last-angiogram-carotid-test",
    component: SurveyStepLastAngiogramCarotid,
    active: true
  },
  {// 28
    id: "artery-blockage",
    component: SurveyStepArteryBlockage,
    active: true
  },
  {// 29
    id: "artery-blockage-experience",
    component: SurveyStepArteryBlockageExperience,
    active: true
  },
  {// 30
    id: "artery-symptom-dates",
    component: SurveyStepArterySymptomDates,
    active: true
  },
  {// 31
    id: "stroke-experience",
    component: SurveyStepStrokeExperience,
    active: true
  },
  {// 32
    id: "stroke-dates",
    component: SurveyStepStrokeDates,
    active: true
  },
  {// 33
    id: "heart-attack-experience",
    component: SurveyStepHeartAttackExperience,
    active: true
  },
  {// 34
    id: "heart-attack-dates",
    component: SurveyStepHeartAttackDates,
    active: true
  },
  {// 35
    id: "heart-artery-procedures",
    component: SurveyStepHeartArteryProcedures,
    active: true
  },
  {// 36
    id: "heart-balloon-opening-dates",
    component: SurveyStepHeartBalloonOpeningDates,
    active: true
  },
  {// 37
    id: "heart-stent-dates",
    component: SurveyStepHeartStentDates,
    active: true
  },
  {// 38
    id: "heart-bypass-surgery-dates",
    component: SurveyStepHeartBypassSurgeryDates,
    active: true
  },
  {// 39
    id: "leg-artery-procedures",
    component: SurveyStepLegArteryProcedures,
    active: true
  },
  {// 40
    id: "leg-ballon-opening-dates",
    component: SurveyStepLegBalloonOpeningDates,
    active: true
  },
  {// 41
    id: "leg-stent-dates",
    component: SurveyStepLegStentDates,
    active: true
  },
  {// 42
    id: "leg-bypass-surgery-dates",
    component: SurveyStepLegBypassSurgeryDates,
    active: true
  },
  {// 43
    id: "neck-artery-procedures",
    component: SurveyStepNeckArteryProcedures,
    active: true
  },
  {// 44
    id: "neck-blockage-surgery-dates",
    component: SurveyStepNeckBlockageSurgeryDates,
    active: true
  },
  {// 45
    id: "neck-stent-dates",
    component: SurveyStepNeckStentDates,
    active: true
  },
  //Section 5
  {// 46
    id: "highest-cholesterol-level",
    component: SurveyStepHighestCholesterolLevel,
    active: true,
    header: "Information about blood lipids (cholesterol and triglycerides) and lipoproteins (particles that carry cholesterol in the blood) is an important part of your cardiometabolic health."
  },
  {// 47
    id: "cholesterol-range",
    component: SurveyStepCholesterolRange,
    active: true
  },
  {// 48
    id: "hypercholesterolemia",
    component: SurveyStepHypercholesterolemia,
    active: true
  },
  {// 49
    id: "hypercholesterolemia-test",
    component: SurveyStepHypercholesterolemiaTest,
    active: true
  },
  {// 50
    id: "hypercholesterolemia-diagnoses",
    component: SurveyStepHypercholesterolemiaDiagnoses,
    active: true
  },
  {// 51
    id: "family-diagnoses",
    component: SurveyStepFamilyDiagnoses,
    active: true
  },
  {// 52
    id: "hypercholesterolemia-family-diagnoses",
    component: SurveyStepHypercholesterolemiaFamilyDiagnoses,
    active: true
  },
  {// 53
    id: "lowest-cholesterol-level",
    component: SurveyStepLowestCholesterolLevel,
    active: false
  },
  {// 54
    id: "highest-triglyceride-level",
    component: SurveyStepHighestTriglycerideLevel,
    active: false
  },
  {// 55
    id: "triglyceride-medication",
    component: SurveyStepTriglycerideMedication,
    active: true
  },
  {// 56
    id: "triglyceride-management",
    component: SurveyStepTriglycerideManagement,
    active: true
  },
  {// 57
    id: "cholesterol-medication",
    component: SurveyStepCholesterolMedication,
    active: true
  },
  {// 58
    id: "cholesterol-statin",
    component: SurveyStepCholesterolStatin,
    active: true
  },
  {// 58b
    id: "cholesterol-medication-during-ascvd",
    component: SurveyStepCholesterolMedicationDuringAscvd,
    active: true
  },
  {// 59
    id: "cholesterol-test",
    component: SurveyStepCholesterolTest,
    active: false
  },
  {// 60
    id: "apoliprotein-b-test",
    component: SurveyStepApolipoproteinBTest,
    active: false
  },
  {// 61
    id: "lipoprotein-a-test",
    component: SurveyStepLipoproteinATest,
    active: false
  },
  //Section 6
  {// 62
    id: "smoking-status",
    component: SurveyStepSmokingStatus,
    active: true,
    header: "Whether you currently or have previously smoked plays an important role in your cardiovascular health."
  },
  {// 63
    id: "smoking-currently",
    component: SurveyStepSmokingCurrently,
    active: true
  },
  {// 64
    id: "smoking-past",
    component: SurveyStepSmokingPast,
    active: true
  },
  {// 64b
    id: "smoking-smokeless",
    component: SurveyStepSmokingSmokeless,
    active: true
  },
  //Section 7
  {// 65
    id: "metabolic-syndrome",
    component: SurveyStepMetabolicSyndrome,
    active: true,
    header: "Several medical conditions run hand-in-hand with cardiometabolic risk. These different conditions have different impacts in determining your risk factors. Please answer the following questions as completely as possible."
  },
  {// 66
    id: "metabolic-conditions",
    component: SurveyStepMetabolicConditions,
    active: true
  },
  {// 67
    id: "conditions-told",
    component: SurveyStepConditionsTold,
    active: true
  },
  {// 68
    id: "ckd",
    component: SurveyStepCKD,
    active: true
  },
  {// 69
    id: "ckd-stage",
    component: SurveyStepCKDStage,
    active: true
  },
  {// 70
    id: "chronic-inflammatory-conditions",
    component: SurveyStepChronicInflammatoryConditions,
    active: true
  },
  {// 71
    id: "sensitivity-hs-crp",
    component: SurveyStepSensitivityHsCrp,
    active: false
  },
  {// 71a
    id: "glyca",
    component: SurveyStepGlyca,
    active: false
  },
  {// 72
    id: "female-medical-conditions",
    component: SurveyStepFemaleMedicalConditions,
    active: true
  },
  {//76
    id: "erectile-dysfunction",
    component: SurveyStepErectileDysfunction,
    active: false
  },
  {// payment
    id: "payment",
    component: SurveyStepPayment,
    active: true
  },
  // Section 8 
  {// 71
    id: "informed-about-health",
    component: SurveyStepReportInformed,
    active: true,
    header: "Understanding how you have used your Cardiometabolic Risk Assessment is important to help us continuously improve our products to help you identify your risk. These last 3 questions are about the changes you have made as a result of your risk assessment report(s)."
  },
  {// 72
    id: "lifestyle-recommendation",
    component: SurveyStepLifestyleRecommendation,
    active: true
  },
  {// 73
    id: "change-following",
    component: SurveyStepChangeFollowing,
    active: true
  },
  {// 74
    id: "health-control",
    component: SurveyStepHealthControl,
    active: true
  },
]

export const lifestyleFactorSectionSteps = [
  {
    id: "physical-rating",
    component: SurveyPhysicalRating,
    active: true,
  },
  {
    id: "mental-rating",
    component: SurveyMentalRating,
    active: true,
  },
  {
    id: "sleep-rating",
    component: SurveySleepRating,
    active: true,
  },
  {
    id: "stress-management-rating",
    component: SurveyStressManagementRating,
    active: true,
  },
  {
    id: "nutritional-rating",
    component: SurveyNutritionalRating,
    active: true,
  },
  {
    id: "exercise-rating",
    component: SurveyExerciseRating,
    active: true,
  },
]
